const doc = [({"ja":({"adminConstantPromotionStatus":({"enabled":"有効", "disabled":"無効"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;